import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect, useRef } from 'react';
import { sendChatMessage } from '../store/actions/chatbotActions'; // adjust path as needed
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import Draggable from 'react-draggable';
import { useDispatch } from 'react-redux';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github.css'; // or any other theme

const Chatbot = ({ visible, messages, loading, sendChatMessageFN }) => {

  const [expanded, setExpanded] = useState(true);
  const [input, setInput] = useState('');
  // const [messages, setMessages] = useState([
  //   { type: 'bot', text: 'Hi! How can I help you today?' }
  // ]);
  const messagesEndRef = useRef(null);

  const dispatch = useDispatch();

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
    setExpanded(true)
  }, [messages, visible]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;
  
    const userMessage = input.trim();
    dispatch({ type: 'CHATBOT_MESSAGE_SEND_USER', payload: userMessage });    setInput('');
    setExpanded(true);
    sendChatMessageFN(userMessage);
    
  };

  const chatbotVariants = {
    hidden: { opacity: 0, y: -20, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: 'spring', stiffness: 300, damping: 24 },
    // transition: { duration: 0.2 },

    },
    exit: {
      opacity: 0,
      y: -20,
      scale: 0.95,
       transition: { duration: 0.8 },
    },
  };

  const sizeClass = expanded
    ? 'w-[600px] h-[800px]'
    : 'w-[600px] h-[360px]';

    console.log("Chatbot loading?", loading);

  return (
<AnimatePresence>
  {visible && (
    <motion.div
      key="chatbot"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Draggable handle=".chatbot-header">
        <div
          className={`fixed top-24 right-6 z-50 ${sizeClass} rounded-2xl shadow-xl border border-white/30 bg-white/30 backdrop-blur-lg flex flex-col overflow-hidden`}
        >
          <div className="px-4 py-2 text-sm font-semibold text-gray-800 border-b border-white/20 bg-white/40 chatbot-header cursor-move">
            <span className="text-gray-700">Rabo Assistant</span>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-2 text-sm">
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={`max-w-[80%] px-3 py-2 rounded-lg whitespace-pre-wrap ${
                  msg.type === 'user'
                    ? 'bg-[#3b3b3b] text-white self-end ml-auto shadow-xl'
                    : 'bg-transparent text-gray-900'
                }`}
              >
                {msg.type === 'bot' ? (
                  <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  rehypePlugins={[rehypeHighlight]}
                  className="prose prose-sm max-w-none"
                >
                  {msg.text}
                </ReactMarkdown>
                ) : (
                  msg.text
                )}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <form
            onSubmit={handleSubmit}
            className="p-2 bg-white/40 border-t border-white/20"
          >
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask anything..."
              className="w-full px-4 py-2 text-sm bg-white/80 text-gray-800 placeholder-gray-500 rounded-md shadow-inner outline-none focus:ring-2 focus:ring-blue-400"
            />
          </form>
        </div>
      </Draggable>
    </motion.div>
  )}
</AnimatePresence>
  );
};

const mapStateToProps = (state) => ({
    visible: state.chatbot.visible,
    messages: state.chatbot.messages,
    loading: state.chatbot.loading,
  });
  
  const mapDispatchToProps = (dispatch) => ({
    sendChatMessageFN: (message) => dispatch(sendChatMessage(message)),
  });

export default connect(mapStateToProps, mapDispatchToProps)(Chatbot);